import { useDispatch, useSelector } from "react-redux";
import { deleteCustomer } from "../services/customerDeleteService";
import { fetchCustomers } from "../../../../../redux/customers/customerSlice";
import {
  selectCurrentPage,
  selectRowsPerPage,
} from "../../../../../redux/customers/customerPaginationSlice";
import {
  clearSelectedCustomer,
  selectedSelectedCustomer,
} from "../../../../../redux/customers/selectedCustomerSlice";

const useCustomerDelete = () => {
  const dispatch = useDispatch();
  const selectedCompany = useSelector(selectedSelectedCustomer);
  const currentPage = useSelector(selectCurrentPage);
  const rowsPerPage = useSelector(selectRowsPerPage);

  const deleteSelectedCustomer = async () => {
    if (!selectedCompany) {
      throw new Error("Please select a Customer to delete.");
    }
    try {
      await deleteCustomer(selectedCompany.customerID);
      dispatch(clearSelectedCustomer());
      // Re-fetch customers using current pagination values
      dispatch(fetchCustomers({ currentPage, rowsPerPage, searchQuery: "" }));
      return true;
    } catch (error) {
      throw error;
    }
  };

  return deleteSelectedCustomer;
};

export default useCustomerDelete;
